import React from 'react';
import { Button } from 'react-bootstrap';
import { Building2 } from 'lucide-react';

import SettingsCard from '../SettingsCard';

const isOwner = (company) =>
  Array.isArray(company.roles) &&
  company.roles.some((r) => r === 'Owner');

// Companies section of the user settings — the list of companies the user
// belongs to, their roles, and leave/delete actions. Data and handlers live in
// the UserSettings shell; the delete-company modal is rendered by the shell.
const CompaniesSection = ({
  associatedCompanies,
  leavingCompanyId,
  handleLeaveCompany,
  setDeleteTarget,
}) => (
  <SettingsCard
    id="foretag"
    icon={Building2}
    title="Företag"
    subtitle="Företag du har tillgång till och vilka roller du har."
  >
    {associatedCompanies.length === 0 ? (
      <p style={{ margin: 0, color: '#737B8B' }}>Du är inte kopplad till några företag.</p>
    ) : (
      <div className="user-settings__company-list">
        {associatedCompanies.map((company) => (
          <div key={company.company_id} className="user-settings__company-row">
            <div>
              <div className="user-settings__company-name">{company.company_name}</div>
              {company.registration_number && (
                <div className="user-settings__company-meta">
                  Org.nr {company.registration_number}
                </div>
              )}
            </div>
            <div className="user-settings__company-row-right">
              <div className="user-settings__roles">
                {(Array.isArray(company.roles) ? company.roles : []).map((role) => (
                  <span key={role} className="user-settings__role-pill">{role}</span>
                ))}
              </div>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => handleLeaveCompany(company)}
                disabled={leavingCompanyId === company.company_id}
              >
                {leavingCompanyId === company.company_id ? 'Lämnar...' : 'Lämna'}
              </Button>
              {isOwner(company) && (
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => setDeleteTarget(company)}
                >
                  Ta bort
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>
    )}
  </SettingsCard>
);

export default CompaniesSection;
